var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2123_2114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7831 7.04983C20.8414 6.04149 19.2581 5.98316 18.2331 6.94149L10.2748 14.8915C10.1789 14.9873 10.1164 15.1123 10.0998 15.2457L9.65812 18.304C9.62895 18.4998 9.69562 18.6957 9.83312 18.8332C9.94978 18.9498 10.1123 19.0165 10.2748 19.0165C10.3039 19.0165 10.3331 19.0165 10.3623 19.0123L13.4623 18.5707C13.5956 18.5498 13.7206 18.4915 13.8164 18.3957L21.7831 10.4623C22.6748 9.50816 22.6748 8.00816 21.7831 7.05399V7.04983ZM20.8831 9.58733L13.0789 17.3582L11.0123 17.654L11.3039 15.629L19.0998 7.84149C19.6039 7.37066 20.3956 7.39983 20.8664 7.90399C21.3123 8.38316 21.3123 9.12899 20.8831 9.59149V9.58733Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 17C16.5292 17 16.25 17.2792 16.25 17.625V20.125C16.25 20.4708 15.9708 20.75 15.625 20.75H4.375C4.02917 20.75 3.75 20.4708 3.75 20.125V5.54167C3.75 5.19583 4.02917 4.91667 4.375 4.91667H5.83333V5.33333C5.83333 6.02083 6.39583 6.58333 7.08333 6.58333H12.9167C13.6042 6.58333 14.1667 6.02083 14.1667 5.33333V4.91667H15.625C15.9708 4.91667 16.25 5.19583 16.25 5.54167C16.25 5.8875 16.5292 6.16667 16.875 6.16667C17.2208 6.16667 17.5 5.8875 17.5 5.54167C17.5 4.50833 16.6583 3.66667 15.625 3.66667H14.1667V3.25C14.1667 2.5625 13.6042 2 12.9167 2H7.08333C6.39583 2 5.83333 2.5625 5.83333 3.25V3.66667H4.375C3.34167 3.66667 2.5 4.50833 2.5 5.54167V20.125C2.5 21.1583 3.34167 22 4.375 22H15.625C16.6583 22 17.5 21.1583 17.5 20.125V17.625C17.5 17.2792 17.2208 17 16.875 17ZM7.08333 3.25H12.9167V5.33333H7.08333V4.29583V3.25Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 9.2915C13.3333 8.94567 13.0542 8.6665 12.7083 8.6665H6.875C6.52917 8.6665 6.25 8.94567 6.25 9.2915C6.25 9.63734 6.52917 9.9165 6.875 9.9165H12.7083C13.0542 9.9165 13.3333 9.63734 13.3333 9.2915Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 12.4165C6.52917 12.4165 6.25 12.6957 6.25 13.0415C6.25 13.3873 6.52917 13.6665 6.875 13.6665H8.95833C9.30417 13.6665 9.58333 13.3873 9.58333 13.0415C9.58333 12.6957 9.30417 12.4165 8.95833 12.4165H6.875Z",
    fill: "#194142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2123_2114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.95,
    height: 20,
    fill: "white",
    transform: "translate(2.5 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.5943a121e7fb1b2b9743f6c2322f5277.svg";
export { ForwardRef as ReactComponent };